import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const GridStyled = styled(Grid, {
  name: 'GridStyled',
})(() => ({
  minHeight: '75px',
}));
